import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { Link } from "react-router-dom";
import { MoreVertIcon, List, ListItem, ListItemText, Divider, Popover } from "../..";
import { Button } from "@material-ui/core";

var ButtonPopover = function ButtonPopover(props) {
  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var createContent = function createContent() {
    return /*#__PURE__*/React.createElement(List, {
      key: "popover_".concat(props.id || "default"),
      component: "div",
      disablePadding: true
    }, props.labels.map(function (item) {
      return createItemPopover(item);
    }));
  };

  var createItemPopover = function createItemPopover(item) {
    switch (item.variant) {
      case "component":
        return /*#__PURE__*/React.createElement(ListItem, null, item.component);

      case "link":
        return /*#__PURE__*/React.createElement(ListItem, {
          component: Link,
          to: item.route,
          button: true,
          key: "".concat(item.name, "-").concat(item._id)
        }, /*#__PURE__*/React.createElement(ListItemText, {
          primary: item.label
        }));

      case "button":
        return /*#__PURE__*/React.createElement(ListItem, {
          button: true,
          key: "".concat(item._id),
          onClick: function onClick() {
            handleClose();
            props.handleItemClick(item._id);
          }
        }, /*#__PURE__*/React.createElement(ListItemText, {
          primary: item.label
        }));

      default:
        break;
    }
  };

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var open = Boolean(anchorEl);
  return [/*#__PURE__*/React.createElement(Button, {
    variant: props.variantButton,
    onClick: function onClick(e) {
      handleClick(e);
    },
    color: props.colorButton
  }, props.children), /*#__PURE__*/React.createElement(Popover, {
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: props.anchorOrigin,
    transformOrigin: props.transformOrigin
  }, createContent())];
};

ButtonPopover.defaultProps = {
  variantButton: "contained",
  colorButton: "primary",
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "right"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "right"
  }
};
export { ButtonPopover };